import model from '@/models/Survey'
import {
    GET_SINGLE,
    GET_LIST
} from '../actions.type'
import {
    SET_SINGLE,
    SET_LIST
} from '../mutations.type'

export const MODULE_NAME = 'SURVEYS'

const initialState = {
    single: null,
    list: []
}

export const state = Object.assign({}, initialState)

const actions = {
    [GET_SINGLE]: ({
        commit
    }, {
        id = null
    }) =>
        new Promise((resolve, reject) => {
            if (id === null) {
                reject(
                    new Error(
                        'Required property id is not set in: surveys module, action GET_SINGLE'
                    )
                )
            } else {
                model
                    .getSingle(id)
                    .then(({
                        data
                    }) => {
                        commit(SET_SINGLE, {
                            result: {
                                data
                            }
                        })
                        resolve({
                            data
                        })
                    }).catch(error => {
                        if (error.response && error.response.status && error.response.status === 404) {
                            resolve({
                                data: []
                            })
                        } else {
                            reject(error)
                        }
                    })
            }
        }),
    [GET_LIST]: ({
        commit
    }, {
        query = {}
    }) => new Promise((resolve, reject) => {
        return model
            .getList(query)
            .then(({
                data,
                headers
            }) => {
                commit(SET_LIST, {
                    result: {
                        total: parseInt(headers['x-total-count']),
                        data
                    }
                })
                resolve({
                    data,
                    headers
                })
            }).catch(error => {
                if (error.response && error.response.status && error.response.status === 404) {
                    resolve({
                        data: [],
                        headers: {
                            'x-total-count': 0
                        }
                    })
                } else {
                    reject(error)
                }
            })

    }),
}

const mutations = {
    [SET_SINGLE] (state, {
        result
    }) {
        state.single = result.data
    },
    [SET_LIST] (state, {
        result
    }) {
        state.list = result
    },
}

const getters = {
    getSingle: state => {
        if (state.single) {
            return state.single
        }
        return null
    },
    getList: state => {
        if (state.list) {
            return state.list
        }
        return null
    },
}

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
}
